import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// View Components
import Frog from './views/Frog.vue'
import Announcement from './views/Announcement.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Frog,
      meta: { page: { title: 'Frog 離反予報' } },
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: Announcement,
      meta: { page: { title: 'お知らせ' } },
    },
    {
      path: '/about',
      name: 'about',
      meta: { page: { title: 'About' } },
      // ルート単位でのコード分割
      // ビルドしたときにメインのスクリプトとは別に `about.[hash].js` がこのルート用に作成されます。
      // このルートを表示するときになって初めてロードされるので、使用頻度が低いルートの場合は
      // こうしておくとパフォーマンス、ビルドしたjsのファイルサイズ削減に役立ちます。
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      // 共通で使うUIエレメントの載せる（開発時に見るページです。）
      path: '/ui-elements',
      name: 'ui-elements',
      component: () => import('./views/UiElements.vue'),
    },
    {
      // SPAをサーバーにデプロイするとき、どのパスでもとりあえずindex.htmlを返すように設定します。
      // ※ 例えば、/help/ponでリロードするとサーバーには/help/ponのURLでリクエストする。
      //    そういうときもサーバーでちゃんとindex.htmlを返さないと404になってしまう。
      // このRouterでパスが見つからない場合<router-view>に何も表示されないことになってしまう
      // ので、どのルートにもマッチしなかった場合は404用のコンポーネントを描画します。
      path: '*',
      component: NotFound,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const account = store.state.account

  if (to.meta && to.meta.admin) {
    if (!account.roles.includes('admin')) {
      next({
        path: '/',
      })
      return
    }
  }

  setDocumentTitle(to)

  next()
})

/**
 * meta.page.titleに設定されている文字列をdocument.titleとします。
 * ただし、分析画面のルートはnameだけ定義していて、to.meta.page.titleは定義していません。
 * その場合はメニュー一覧からtoのメニューを探してその日本語名を設定します。
 *
 * 何れもマッチしない場合、document.titleには何も設定されません。
 *
 * @param {Object} to
 * @param {Array} queryMenus
 */
function setDocumentTitle(to) {
  if (to.meta && to.meta.page && to.meta.page.title) {
    document.title = `${to.meta.page.title}`
    return
  }
}

export default router
